import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { concat } from 'lodash';

import initialCompany from '../../../pages/initialCompany';
import S1_3_UserAdd from '../../../pages/s1_3_Hereglegch';
import S1_1_TatvarJil from '../../../pages/s1_1_TatvarJil';
import S1_2_RoleAdd from '../../../pages/s1_2_ErhiinTohirgoo';
import S4_1_TatvarTulugchMedeelel from '../../../pages/s4_1_TatvarTulugch';
import S4_2_HereglegchMedeelel from '../../../pages/userProfile/newUserProfile';

export const routeList = {
  Home: {
    path: '/company',
    component: initialCompany,
    permission: false,
  },
  S1_2_RoleAdd: {
    path: '/company/tohirgoo/roleAdd',
    component: S1_2_RoleAdd,
    permission: false,
  },
  S1_3_UserAdd: {
    path: '/company/tohirgoo/userAdd',
    component: S1_3_UserAdd,
    permission: false,
  },
  S4_1_TatvarTulugchMedeelel: {
    path: '/company/tatvarTulugch/medeelel',
    component: S4_1_TatvarTulugchMedeelel,
    permission: false,
  },
  HereglegchMedeelel: {
    path: '/company/hereglegchMedeelel',
    component: S4_2_HereglegchMedeelel,
    permission: false,
  },
};

const Entity = () => {
  let childList = [];
  Object.values(routeList).forEach((i) => {
    const { children = [] } = i;
    if (children.length > 0) {
      childList = concat(childList, children);
    }
  });
  const mainList = [...Object.values(routeList), ...childList];
  return (
    <Switch>
      {mainList.map(({ path, component }, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <Route exact path={path} component={component} key={key} />
      ))}
    </Switch>
  );
};

export default Entity;
